export default __webpack_public_path__ + "static/media/alert-warning.8615a4ab.svg";